'use client';

import { c as _c } from "react/compiler-runtime";
import type { ChainId } from '@morpho-org/blue-sdk';
import { cn } from '@morpho-org/ui-v6/utils';
import { Icon } from '@repo/ui';
import { Timelock } from '@repo/ui/icons';
import type { PendingTimelocks } from './types';
import { formatPendingActionsLabel, PendingActionsList, VaultPendingTimelockInfo } from '../../components/VaultPendingTimelockInfo';
import VaultPendingTimelock from '../VaultPendingTimelock/VaultPendingTimelock';
interface VaultHeroPendingActionsProps {
  chainId: ChainId;
  pendingTimelocks: PendingTimelocks;
}
const VaultHeroPendingActions = t0 => {
  const $ = _c(38);
  const {
    chainId,
    pendingTimelocks: data
  } = t0;
  const {
    pendingTimelocks,
    hasCriticalAction,
    marketSupplyCaps,
    currentGuardian,
    currentGuardianMetadata,
    currentTimelock
  } = data;
  if (pendingTimelocks.length === 0) {
    return null;
  }
  let t1;
  if ($[0] !== pendingTimelocks.length) {
    t1 = formatPendingActionsLabel(pendingTimelocks.length);
    $[0] = pendingTimelocks.length;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const pendingActionsText = t1;
  const t2 = pendingTimelocks.length;
  let t3;
  if ($[2] !== chainId || $[3] !== currentGuardian || $[4] !== currentGuardianMetadata || $[5] !== currentTimelock || $[6] !== marketSupplyCaps || $[7] !== pendingTimelocks) {
    let t4;
    if ($[9] !== chainId || $[10] !== currentGuardian || $[11] !== currentGuardianMetadata || $[12] !== currentTimelock || $[13] !== marketSupplyCaps) {
      t4 = (item, index) => <VaultPendingTimelock key={`${item.txHash}-${item.functionName}-${index}`} chainId={chainId} marketSupplyCaps={marketSupplyCaps} validAt={item.validAt} functionName={item.functionName} decodedData={item.decodedData} currentGuardian={currentGuardian} currentGuardianMetadata={currentGuardianMetadata} currentTimelock={currentTimelock} />;
      $[9] = chainId;
      $[10] = currentGuardian;
      $[11] = currentGuardianMetadata;
      $[12] = currentTimelock;
      $[13] = marketSupplyCaps;
      $[14] = t4;
    } else {
      t4 = $[14];
    }
    t3 = pendingTimelocks.map(t4);
    $[2] = chainId;
    $[3] = currentGuardian;
    $[4] = currentGuardianMetadata;
    $[5] = currentTimelock;
    $[6] = marketSupplyCaps;
    $[7] = pendingTimelocks;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[15] !== pendingTimelocks.length || $[16] !== t3) {
    t4 = <PendingActionsList count={t2} data-testid="vault-hero-pending-actions-content">{t3}</PendingActionsList>;
    $[15] = pendingTimelocks.length;
    $[16] = t3;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  const pendingActionsContent = t4;
  const t5 = hasCriticalAction ? "bg-destructive-foreground/20 hover:bg-destructive-foreground/25 text-destructive-foreground hover:text-destructive-foreground active:text-destructive-foreground disabled:text-destructive-foreground/35" : "bg-primary/15 hover:bg-primary/20";
  let t6;
  if ($[18] !== t5) {
    t6 = cn("flex h-[26px] cursor-default items-center justify-center gap-0.5 rounded-full pr-[10px] pl-[5px]", t5);
    $[18] = t5;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Timelock />;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  const t8 = hasCriticalAction ? "text-destructive-foreground" : "text-info-foreground";
  let t9;
  if ($[21] !== t8) {
    t9 = cn("size-5", t8);
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== t9) {
    t10 = <Icon icon={t7} className={t9} />;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  const t11 = hasCriticalAction ? "text-destructive-foreground" : "text-info-foreground";
  let t12;
  if ($[25] !== t11) {
    t12 = cn("text-3xs", t11);
    $[25] = t11;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = {
      lineHeight: "normal",
      whiteSpace: "nowrap"
    };
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== pendingActionsText || $[29] !== t12) {
    t14 = <span className={t12} style={t13}>{pendingActionsText}</span>;
    $[28] = pendingActionsText;
    $[29] = t12;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== t10 || $[32] !== t14 || $[33] !== t6) {
    t15 = <div className="gap-sm flex flex-row items-center" data-testid="vault-hero-pending-actions-trigger"><div className={t6}>{t10}{t14}</div></div>;
    $[31] = t10;
    $[32] = t14;
    $[33] = t6;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== pendingActionsContent || $[36] !== t15) {
    t16 = <VaultPendingTimelockInfo content={pendingActionsContent}>{t15}</VaultPendingTimelockInfo>;
    $[35] = pendingActionsContent;
    $[36] = t15;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  return t16;
};
export default VaultHeroPendingActions;